<template>
  <nav class="site-navigation">
    <div v-if="!onlyPagination">
      <h5>Filter</h5>
      <div class="search-mask">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
        <input
          :value="sort.search"
          @input="search"
          class="search"
          placeholder="Objekte durchsuchen"
          type="text"
        />
      </div>
      <div>
        <button class="rentorbuy" @click="sortBuy" :class="{active: !sort.rent}">Kaufen</button>
        <button class="rentorbuy" @click="sortRent" :class="{active: sort.rent}">Mieten</button>
      </div>
      <div class="place-selection">
        <span>Ort</span>
        <select name="Ort" @input="changePlace">
          <option value="all">Alle</option>
          <option
            v-for="place in places"
            :key="place[0]"
            :value="place[0]"
          >{{place[0]}} ({{place[1]}})</option>
        </select>
      </div>
      <a class="price-sort" @click="togglePriceSorting" :class="{active: sort.priceAsc}">
        Preis
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style="transform-origin: 50% 50%;"
          enable-background="new 0 0 24 24"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <g>
            <rect fill="none" height="24" width="24" />
            <path
              d="M12,4c4.41,0,8,3.59,8,8s-3.59,8-8,8s-8-3.59-8-8S7.59,4,12,4 M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10 c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2L12,2z M13,12l0-4h-2l0,4H8l4,4l4-4H13z"
            />
          </g>
        </svg>
      </a>
    </div>
    <div class="pagination" v-if="numPages > 0">
      <h5>Seiten</h5>
      <a
        href="#"
        v-for="i in numPages"
        @click="changePage(i)"
        :class="{active: i === currPage}"
        :key="'link'+i"
      >{{i}}</a>
    </div>
  </nav>
</template>

<script>
export default {
  data: () => ({}),
  computed: {},
  methods: {
    changePlace (ev) {
      const newSort = { ...this.sort, place: ev.target.value }
      this.changeSorting(newSort)
    },
    togglePriceSorting () {
      const newSort = { ...this.sort, priceAsc: !this.sort.priceAsc }
      this.changeSorting(newSort)
    },
    sortBuy () {
      const newSort = { ...this.sort, rent: false }
      this.changeSorting(newSort)
    },
    sortRent () {
      const newSort = { ...this.sort, rent: true }
      this.changeSorting(newSort)
    },
    search (ev) {
      const newSort = { ...this.sort, search: ev.target.value }
      this.changeSorting(newSort)
    }
  },
  props: [
    'numPages',
    'changePage',
    'currPage',
    'changeSorting',
    'sort',
    'places',
    'onlyPagination'
  ]
}
</script>

<style scoped>
* {
  box-sizing: initial;
}

nav.site-navigation a {
  margin: 0 8px;
  color: #71b100;
  font-weight: bold;
  text-decoration: none;
}

nav.site-navigation a.price-sort {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
}

nav.site-navigation a.price-sort svg {
  margin-left: 0.3em;
  fill: #71b100;
  transition: all 0.3s ease-in-out;
}

nav.site-navigation .search-mask {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

nav.site-navigation .search-mask svg {
  background-color: #71b100;
  fill: #fff;
  height: 15px;
  padding: 4px;
  border: 1px solid #71b100aa;
}

nav.site-navigation .place-selection span {
  background-color: #71b100;
  color: #fff;
  height: 15px;
  font: 400 13.3333px Arial;
  text-transform: uppercase;
  padding: 4px 8px;
  letter-spacing: 0.05em;
  border: 1px solid #71b100aa;
}

nav.site-navigation .place-selection select {
  background-color: #71b10020;
  border: 1px solid #71b100aa;
  outline: none;
  padding: 3px 8px;
  color: #000000aa;
  letter-spacing: 0.05em;
}

nav.site-navigation a.price-sort.active svg {
  transform: rotateZ(180deg);
}

nav.site-navigation .pagination a.active {
  text-decoration: none;
  cursor: auto;
  color: black;
  font-weight: normal;
}

nav.site-navigation {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

nav.site-navigation > div:first-child {
  margin: 0 -4px;
}

.place-selection select,
.place-selection select option,
.place-selection select option:focus,
.place-selection select option:hover,
.place-selection select:focus {
  outline: none !important;
  /* border: none !important; */
  text-align: center;
}

nav.site-navigation button, nav.site-navigation input, nav.site-navigation select, nav.site-navigation textarea {
    line-height: 1.1em;
}

nav.site-navigation > div:first-child input,
nav.site-navigation > div:first-child button,
nav.site-navigation > div:first-child select {
  border-radius: 0;
  margin: 0;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

nav.site-navigation > div:first-child h5 {
  line-height: 24px;
}

nav.site-navigation > div:first-child * {
  box-sizing: border-box;
}

nav.site-navigation > div:first-child > * {
  flex-grow: 1;
  flex-shrink: 0;
  margin: 8px 4px;
  display: flex;
  height: 24px;
}

nav.site-navigation > div:first-child > * > * {
  flex: 1;
  height: 100%;
}

nav.site-navigation > * {
  text-align: left;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

nav.site-navigation h5 {
  margin: 8px 0;
  text-align: left;
  display: inline;
  padding-right: 8px;
  margin-right: 16px;
  /* border-right: 1px solid gray; */
}

nav.site-navigation button.rentorbuy {
  transition: all 0.2s ease-in-out;
  background-color: #71b10020;
  border: 1px solid #71b100aa;
  outline: none;
  text-transform: uppercase;
  padding: 4px 8px;
  color: #000000aa;
  letter-spacing: 0.05em;
  /* font-weight: bold; */
}

nav.site-navigation button.rentorbuy.active {
  color: #fff;
  background-color: #71b100;
}

nav.site-navigation input.search {
  padding: 4px;
  border: 1px solid #71b100aa;
  outline: none;
}

@media only screen and (max-width: 400px) {
  nav.site-navigation > div:first-child > * {
    /* display: block; */
  }
}
</style>
